import React from "react";
import { Box, Grid, Typography } from "@mui/material";

export default function AlternatingInfoBlock({
  title,
  subtitle,
  description,
  image,
  reverse = false,
  titleColor,
}) {
  return (
    <Box sx={{py:4, px: { xs: 2, md: 6 }, display:'flex', justifyContent:'center' }}>
      <Grid
        container
        
        direction={reverse ? "row-reverse" : "row"}
        alignItems="center"
        sx={{maxWidth:'1190px', py:{xs:0,mx:4}}}
      >
        {/* TEXT SECTION */}
        <Grid item xs={12} md={6} display='flex' flexDirection='column' 
        sx={{alignItems: {xs: 'center', md: reverse ? 'flex-start' : 'flex-end',}, p:5 }}>
          <Typography  sx={{textAlign:{xs:'center', md: reverse ? 'left' : 'right' }, fontWeight: 900, mb: 1, fontSize:{xs:'26px', md:'30px'}, lineHeight:1 }}>
            {title}
          </Typography>
          <Typography
            
            textAlign={reverse ? 'left' : 'right'}
            sx={{ color: titleColor || '#000', fontWeight: "bold", mb: 2, fontSize:'16px', textTransform:'uppercase' }}
          >
            {subtitle}
          </Typography>
          <Typography
  sx={{
    fontSize: "14px",
    textAlign: "justify",
    color: "#444",
    maxWidth: '515px',
  }}
>
  {description}
</Typography>

          
        </Grid>

        {/* IMAGE SECTION */}
        <Grid item xs={12} md={6} display='flex' flexDirection='column' sx={{alignItems: {xs: 'center', md: reverse ? 'flex-end' : 'flex-start',}, px:3 }}>
          <Box
            component="img"
            src={image}
            alt={title}
            borderRadius= {reverse ? '100px 0px 0px 0px' : ' 0px 100px 0px 0px'} 
            sx={{
              width: "100%",
              maxWidth:'560px',
              maxHeight:'370px',
              
              filter: "grayscale(100%)", // opcional si quieres el look en B&N
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
